<uimc-filtered-select-v2 
        [labelSearch]="'PLACEHOLDER_TYPE_FILTER' | translate" 
        [label]="'TEXT_LEARNINGPLAN' | translate" 
        [selectedItem]="selectedItem"
        (selectedItemChange)="onSelectedEventType($event)"
        [filterThreshold]="2"
        class="col-sm-12 padding-zero">
    <option *ngFor="let option of options" [value]="option.value">{{option.name}}</option>
</uimc-filtered-select-v2>
